<div class="row page-title">
  <span>{{ localizationConstants.PURCHASE_ORDER_PAGE_TITLE | translate }}</span>
</div>

<div
  class="row"
  *ngIf="!poResult && !basket.tools?.length">
  <div class="col center c-submit">
    <div class="c-submit__title">
      {{ "purchaseorder.notoolsfound" | translate }}
    </div>
    <div class="c-submit__item">
      {{ "purchaseorder.goto" | translate }}
      <a (click)="onMyToolsClick(false)">{{
        localizationConstants.PURCHASE_ORDER_MY_TOOLS | translate
      }}</a>
    </div>
  </div>
</div>

<mat-sidenav-container
  class="service-request-sidenav__container sidenav__container-full-page-height">
  <form
    [hidden]="!basket.tools?.length"
    #poForm="ngForm">
    <div
      class="row u-p-x-only u-mt--large u-mb--large flex between"
      *ngIf="!poResult && basket.tools?.length">
      <div class="c-section-title col-6 col-lg-3">
        {{ basket.tools?.length }}
        {{ localizationConstants.PURCHASE_ORDER_TOOLS | translate }}
      </div>
      <div class="col-6 col-lg-3">
        <button
          type="button"
          class="button button--lg button-primary button-block flex middle center button__stepper-start"
          (click)="onStartCheckoutClick()"
          [class.form-invalid]="poForm.form.invalid">
          <span class="button__label button__mobile-label">{{
            localizationConstants.BUTTON_START_CHECKOUT | translate
          }}</span>
          <mat-icon
            svgIcon="chevronRight"
            color="white"></mat-icon>
        </button>
        <div>
          <span
            class="c-form-alert"
            *ngIf="poForm.form.invalid">
            {{ localizationConstants.SERVICE_REQUEST_FORM_ERRORS | translate }}
          </span>
        </div>
      </div>
    </div>

    <div>
      <div class="row u-p-x-only">
        <div class="col">
          <div class="u-scroll--horizontal">
            <div
              id="purchase-order-table"
              class="col u-table-fix-head">
              <table
                mat-table
                matSort
                [dataSource]="dataSource"
                class="c-table">
                <ng-container
                  *ngFor="let col of columns"
                  [matColumnDef]="col.key">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    {{ col.title | translate }}
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element">
                    <ng-container [ngSwitch]="col.key">
                      <ng-container *ngSwitchCase="'serialNumber'">
                        <span
                          class="c-clickable"
                          [routerLink]="[
                            routeNameConstants.TOOLS_DETAILS_BASE,
                            element.companyId,
                            element.serialNumber,
                          ]"
                          >{{ element[col.key] }}</span
                        >
                      </ng-container>
                      <ng-container *ngSwitchCase="'toolId'">
                        <span
                          class="c-clickable"
                          [routerLink]="[
                            routeNameConstants.TOOLS_DETAILS_BASE,
                            element.companyId,
                            element.serialNumber,
                          ]"
                          >{{ element[col.key] }}</span
                        >
                      </ng-container>
                      <ng-container *ngSwitchCase="'modelNumber'">
                        {{ element[col.key] }}
                      </ng-container>
                      <ng-container *ngSwitchCase="'cost'">
                        {{ element[col.key] !== 0 ? element[col.key] : "N/A" }}
                      </ng-container>
                      <ng-container *ngSwitchCase="'toolQuote'">
                        <download-file
                          *ngIf="element.quote"
                          [file]="element.quote"></download-file>
                      </ng-container>
                    </ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="action1">
                  <th
                    mat-header-cell
                    *matHeaderCellDef>
                    <span class="c-table__column-title">
                      <button
                        (click)="removeAll()"
                        type="button"
                        class="button--sm button-secondary button-block">
                        {{ localizationConstants.PURCHASE_ORDER_REMOVE_ALL | translate }}
                      </button>
                    </span>
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element">
                    <purchase-order-button
                      *ngIf="!poResult"
                      [tool]="element"></purchase-order-button>
                  </td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="columnKeysAll"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: columnKeysAll"
                  class="c-table__row"></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <mat-sidenav
    #sidePurchaseOrderStepper
    position="start"
    class="service-request-sidenav__drawer"
    [fixedInViewport]="true">
    <div class="full-screen-stepper">
      <div style="width: 100%">
        <div class="row service-request-stepper__header">
          <a routerLink="{{ routeNameConstants.ROOT }}"
            ><img
              class="c-logo"
              [src]="brandingService.getBrandLogo()"
              alt="Where Is My Tool"
          /></a>
        </div>
      </div>

      <div class="row stepper-wrapper">
        <mat-stepper
          #stepper
          [linear]="true"
          class="step-content-wrapper">
          <!-- TODO: make stepper vertical on mobile -->
          <ng-template matStepperIcon="edit">
            <mat-icon svgIcon="edit"></mat-icon>
          </ng-template>
          <ng-template matStepperIcon="done">
            <mat-icon svgIcon="checkmark"></mat-icon>
          </ng-template>

          <!-- SHIPPING STEP -->
          <mat-step
            [stepControl]="stepShippingForm.control"
            [editable]="!poResult">
            <ng-template matStepLabel>{{
              localizationConstants.PURCHASE_ORDER_STEP_SHIPPING | translate
            }}</ng-template>

            <div class="stepper-content">
              <div class="stepper-content-main">
                <form
                  #stepShippingForm="ngForm"
                  [id]="enterPOStepperId">
                  <div class="u-flex-column">
                    <div class="col">
                      <section class="u-flex-column">
                        <div class="col-12">
                          <mat-card
                            appearance="outlined"
                            class="stepper-card">
                            <mat-card-header>
                              <mat-card-title>
                                {{ localizationConstants.PURCHASE_ORDER_PROCESS_TYPE | translate }}
                              </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                              <div class="u-pt--medium u-pb--medium">
                                <mat-select
                                  #address="ngModel"
                                  [(ngModel)]="processType"
                                  id="processType"
                                  name="processType"
                                  class="c-select c-select--md u-minw--400 u-w--auto"
                                  type="text">
                                  <mat-option
                                    *ngFor="let option of processTypeList"
                                    [value]="option.key">
                                    {{ option.title | translate }}
                                  </mat-option>
                                </mat-select>
                              </div>
                            </mat-card-content>
                          </mat-card>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="col-12">
                          <mat-card
                            appearance="outlined"
                            class="stepper-card">
                            <mat-card-header>
                              <mat-card-title>
                                {{ localizationConstants.PURCHASE_ORDER_SHIP_TO | translate }}
                              </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                              <table
                                *ngIf="shipToList"
                                class="o-list-table o-list-table--compact">
                                <tr class="o-list-table__item">
                                  <td
                                    scope="row"
                                    class="o-list-table__title">
                                    {{
                                      localizationConstants.SERVICE_REQUEST_STEP_COMPANY | translate
                                    }}
                                  </td>
                                  <td>
                                    {{ companyService.selectedCompany.fullName }}
                                  </td>
                                </tr>
                                <ng-container *ngIf="currentShipTo?.name !== 'other'">
                                  <tr>
                                    <td
                                      scope="row"
                                      class="o-list-table__title">
                                      {{
                                        localizationConstants.SERVICE_REQUEST_STEP_ADDRESS
                                          | translate
                                      }}
                                    </td>
                                    <td class="u-pt--medium">
                                      {{ currentShipTo?.displayName }}
                                    </td>
                                  </tr>
                                  <tr *ngIf="currentShipTo?.address1">
                                    <td
                                      scope="row"
                                      class="o-list-table__title"></td>
                                    <td class="u-pt--medium">
                                      {{ currentShipTo?.address1 }}
                                    </td>
                                  </tr>
                                  <tr *ngIf="currentShipTo?.address2">
                                    <td
                                      scope="row"
                                      class="o-list-table__title"></td>
                                    <td class="u-pt--medium">
                                      {{ currentShipTo?.address2 }}
                                    </td>
                                  </tr>
                                  <tr *ngIf="currentShipTo?.address3">
                                    <td
                                      scope="row"
                                      class="o-list-table__title"></td>
                                    <td class="u-pt--medium">
                                      {{ currentShipTo?.address3 }}
                                    </td>
                                  </tr>
                                </ng-container>
                                <div class="u-mt--medium">&nbsp;</div>
                              </table>
                              <div class="u-pt--medium u-pb--medium">
                                <mat-select
                                  [placeholder]="
                                    localizationConstants.SERVICE_REQUEST_STEP_SHIPPING_PLACEHOLDER
                                      | translate
                                  "
                                  #address="ngModel"
                                  [(ngModel)]="currentShipTo"
                                  id="shipTo"
                                  name="shipTo"
                                  (ngModelChange)="onAddressChange(address.value)"
                                  type="text"
                                  class="c-select c-select--md u-minw--400 u-w--auto">
                                  <mat-option
                                    *ngFor="let shipTo of shipToList"
                                    [value]="shipTo">
                                    {{ shipTo.displayName + " " + shipTo.address1 }}
                                  </mat-option>
                                  <mat-option [value]="{ name: 'other' }">
                                    {{
                                      localizationConstants.SERVICE_REQUEST_STEP_OTHER_ADDRESS
                                        | translate
                                    }}
                                  </mat-option>
                                </mat-select>
                              </div>
                              <textarea
                                *ngIf="!poResult && currentShipTo?.name === 'other'"
                                #customAddress="ngModel"
                                name="customAddress"
                                [(ngModel)]="addressInput"
                                class="c-input c-input--alpha c-textarea"
                                [class.is-invalid]="!addressInput"
                                required>
                              </textarea>
                            </mat-card-content>
                          </mat-card>
                        </div>
                      </section>
                    </div>
                  </div>
                </form>
              </div>
              <div class="stepper-content-side">
                <!-- TODO: create sticky component with summary? -->

                <mat-card appearance="outlined">
                  <mat-card-content class="stepper-detail-card u-flex-column">
                    <div>
                      <p class="c-section-title">
                        {{ localizationConstants.PURCHASE_ORDER_ORDER_SUMMARY | translate }}
                      </p>
                      <mat-divider class="u-mt--medium u-mb--medium"></mat-divider>
                      <div
                        class="u-font-bold u-content-between u-flex-row u-mt--medium u-mb--large">
                        <p>
                          {{ localizationConstants.PURCHASE_ORDER_TOTAL | translate }}
                        </p>
                        <p>{{ totalCosts }}</p>
                      </div>
                      <button
                        (click)="continueStepper()"
                        class="button button-primary button-block flex middle center button__stepper-continue">
                        <span class="button__label button__mobile-label">
                          {{ localizationConstants.BUTTON_CONTINUE | translate }}
                        </span>
                        <mat-icon
                          svgIcon="chevronRight"
                          color="white"></mat-icon>
                      </button>
                    </div>

                    <mat-divider></mat-divider>

                    <button
                      (click)="closeStepper()"
                      class="button button-secondary button-block">
                      {{ localizationConstants.BUTTON_CANCEL | translate }}
                    </button>

                    <div class="c-section-title">
                      {{
                        localizationConstants.PURCHASE_ORDER_SUMMARY_TOOLS
                          | translate: { value: modelsSummaryLength }
                      }}
                    </div>

                    <div class="services-summary">
                      <div
                        *ngFor="let modelProp of modelsSummary | keyvalue"
                        class="services-summary-service">
                        <ul>
                          <li
                            *ngFor="let serialNumber of modelProp.value"
                            class="services-summary-serial">
                            <span>{{ serialNumber }}</span>
                          </li>
                        </ul>
                        <div class="flex end services-summary-service-name">
                          {{ modelProp.key }}
                        </div>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-step>

          <!-- ENTER PO STEP -->
          <mat-step
            #enterPOStep
            [editable]="false"
            [completed]="false">
            <ng-template matStepLabel>{{
              localizationConstants.PURCHASE_ORDER_ENTER_PO_STEP_NAME | translate
            }}</ng-template>

            <div class="stepper-content">
              <div class="stepper-content-main">
                <form
                  #stepEnterPOform="ngForm"
                  [id]="enterPOStepperId">
                  <div class="u-flex-column">
                    <div class="col">
                      <section class="u-flex-column">
                        <div class="col-12">
                          <mat-card
                            appearance="outlined"
                            class="stepper-card">
                            <mat-card-header>
                              <mat-card-title>
                                {{
                                  localizationConstants.SERVICE_REQUEST_STEP_PURCHASE_ORDER_TITLE
                                    | translate
                                }}
                              </mat-card-title>
                              <mat-card-subtitle>
                                <span
                                  *ngIf="!poResult"
                                  class="c-postfix">
                                  ({{ localizationConstants.LABEL_REQUIRED | translate }})
                                </span>
                              </mat-card-subtitle>
                            </mat-card-header>
                            <mat-card-content>
                              <div class="details-step-po-request-section">
                                <input
                                  name="poNumber"
                                  *ngIf="!poResult"
                                  [(ngModel)]="po.poNumber"
                                  type="text"
                                  class="c-input c-input--gamma details-step-po-input"
                                  [class.is-invalid]="isSubmitPOPressed && !po.poNumber"
                                  required />
                              </div>
                              <span
                                *ngIf="
                                  stepEnterPOform?.form?.controls['poNumber']?.errors?.maxlength
                                "
                                class="c-form-alert">
                                {{
                                  localizationConstants.VALIDATION_MAX_LENGTH_MESSAGE
                                    | translate: { value: 50 }
                                }}
                              </span>
                            </mat-card-content>
                          </mat-card>
                        </div>

                        <div class="col-12">
                          <mat-card
                            appearance="outlined"
                            class="stepper-card">
                            <mat-card-header>
                              <mat-card-title>
                                {{
                                  localizationConstants.PURCHASE_ORDER_SUPPORTING_DOCUMENTS
                                    | translate
                                }}
                              </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                              <drag-n-drop
                                *ngIf="!poResult"
                                (file)="attachDocument($event)"></drag-n-drop>
                            </mat-card-content>
                          </mat-card>
                        </div>

                        <div class="col-12">
                          <mat-card
                            appearance="outlined"
                            class="stepper-card">
                            <mat-card-header>
                              <mat-card-title>
                                {{ localizationConstants.SERVICE_REQUEST_STEP_REMARKS | translate }}
                              </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                              <textarea
                                #comments="ngModel"
                                *ngIf="!poResult"
                                [(ngModel)]="po.comments"
                                name="service-request-remarks"
                                class="c-input c-input--alpha c-textarea">
                              </textarea>
                            </mat-card-content>
                          </mat-card>
                        </div>
                      </section>
                    </div>
                  </div>
                </form>
              </div>

              <div class="stepper-content-side">
                <!-- TODO: create sticky component with summary? -->

                <mat-card appearance="outlined">
                  <mat-card-content class="stepper-detail-card u-flex-column">
                    <div>
                      <p class="c-section-title">
                        {{ localizationConstants.PURCHASE_ORDER_ORDER_SUMMARY | translate }}
                      </p>
                      <mat-divider class="u-mt--medium u-mb--medium"></mat-divider>
                      <div
                        class="u-font-bold u-content-between u-flex-row u-mt--medium u-mb--large">
                        <p>
                          {{ localizationConstants.PURCHASE_ORDER_TOTAL | translate }}
                        </p>
                        <p>{{ totalCosts }}</p>
                      </div>
                      <button
                        (click)="onSubmitPoAsync(enterPOStep)"
                        [class.form-invalid]="isSubmitPOPressed && stepEnterPOform.form.invalid"
                        class="button button-primary button-block flex middle center button__stepper-continue">
                        <span class="button__label button__mobile-label">
                          {{ localizationConstants.BUTTON_SUBMIT_PURCHASE_ORDER | translate }}
                        </span>
                        <mat-icon
                          svgIcon="chevronRight"
                          color="white"></mat-icon>
                      </button>

                      <div *ngIf="isSubmitPOPressed && stepEnterPOform.form.invalid">
                        <span class="c-form-alert">
                          {{ localizationConstants.SERVICE_REQUEST_FORM_ERRORS | translate }}
                        </span>
                      </div>
                    </div>

                    <mat-divider></mat-divider>

                    <button
                      (click)="closeStepper()"
                      class="button button-secondary button-block">
                      {{ localizationConstants.BUTTON_CANCEL | translate }}
                    </button>

                    <div class="c-section-title">
                      {{
                        localizationConstants.PURCHASE_ORDER_SUMMARY_TOOLS
                          | translate: { value: modelsSummaryLength }
                      }}
                    </div>

                    <div class="services-summary">
                      <div
                        *ngFor="let modelProp of modelsSummary | keyvalue"
                        class="services-summary-service">
                        <ul>
                          <li
                            *ngFor="let serialNumber of modelProp.value"
                            class="services-summary-serial">
                            <span>{{ serialNumber }}</span>
                          </li>
                        </ul>
                        <div class="flex end services-summary-service-name">
                          {{ modelProp.key }}
                        </div>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-step>

          <!-- CONFIRMATION STEP-->
          <mat-step [editable]="false">
            <ng-template matStepLabel>{{
              localizationConstants.PURCHASE_ORDER_STEP_CONFIRMATION | translate
            }}</ng-template>
            <div class="stepper-header-wrapper u-flex-column u-mt--large u-mb--large">
              <div class="stepper-header-image u-mt--large u-mb--medium">
                <img
                  [src]="brandingService.getBrandBanner()"
                  alt="confirmation" />
                <div class="stepper-header-image-message">
                  {{ localizationConstants.PURCHASE_ORDER_STEP_CONFIRMATION_MESSAGE | translate }}
                </div>
              </div>
              <div class="u-flex-column gap-lg">
                <div class="u-mw--600 u-p-x-medium">
                  {{ localizationConstants.PURCHASE_ORDER_STEP_CONFIRMATION_MESSAGE_2 | translate }}
                  <a (click)="onMyToolsClick()">{{
                    localizationConstants.PURCHASE_ORDER_MY_TOOLS | translate
                  }}</a>
                </div>
                <mat-divider></mat-divider>
              </div>
            </div>

            <div class="stepper-content">
              <div class="stepper-content-main u-flex-column">
                <div class="col">
                  <section class="u-flex-column">
                    <div class="col-12">
                      <mat-card
                        appearance="outlined"
                        class="stepper-card">
                        <mat-card-header>
                          <mat-card-title>
                            {{
                              localizationConstants.PURCHASE_ORDER_FINAL_STEP_PO_SECTION_NAME
                                | translate
                            }}
                          </mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                          <div>
                            <table class="o-list-table o-list-table--compact">
                              <tr class="o-list-table__item">
                                <td
                                  scope="row"
                                  class="o-list-table__title c-col-6">
                                  <h4>
                                    {{
                                      localizationConstants.PURCHASE_ORDER_FINAL_STEP_PO_NUMBER_SECTION_NAME
                                        | translate
                                    }}
                                  </h4>
                                </td>
                                <td class="u-pt--medium">
                                  {{ po.poNumber }}
                                </td>
                              </tr>

                              <tr>
                                <td
                                  scope="row"
                                  class="o-list-table__title c-col-6">
                                  <h4>
                                    {{
                                      localizationConstants.PURCHASE_ORDER_FINAL_STEP_PROCESS_TYPE_SECTION_NAME
                                        | translate
                                    }}
                                  </h4>
                                </td>
                                <td class="u-pt--medium">
                                  {{ processTypeTitle | translate }}
                                </td>
                              </tr>
                              <tr *ngIf="po.document?.fileName">
                                <td
                                  scope="row"
                                  class="o-list-table__title c-col-6">
                                  <h4>
                                    {{
                                      localizationConstants.PURCHASE_ORDER_SUPPORTING_DOCUMENTS
                                        | translate
                                    }}
                                  </h4>
                                </td>
                                <td class="u-pt--medium">
                                  {{ po.document?.fileName }}
                                </td>
                              </tr>

                              <tr *ngIf="po.comments">
                                <td
                                  scope="row"
                                  class="o-list-table__title c-col-6">
                                  <h4>
                                    {{
                                      localizationConstants.PURCHASE_ORDER_FINAL_STEP_REMARKS_SECTION
                                        | translate
                                    }}
                                  </h4>
                                </td>
                                <td class="u-pt--medium">
                                  {{ po.commentsToShow }}
                                </td>
                              </tr>

                              <div class="u-mt--medium">&nbsp;</div>
                            </table>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </div>
                  </section>
                </div>
              </div>

              <div class="stepper-content-side">
                <!-- TODO: create sticky component with summary? -->

                <mat-card appearance="outlined">
                  <mat-card-content class="stepper-detail-card u-flex-column">
                    <div>
                      <button
                        (click)="closeAndResetStepper()"
                        class="button button-secondary button-block flex middle center">
                        <span class="button__label button__mobile-label">
                          {{ localizationConstants.BUTTON_BACK_TO_HOME | translate }}
                        </span>
                        <mat-icon
                          svgIcon="home"
                          color="white"></mat-icon>
                      </button>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="c-section-title">
                      {{
                        localizationConstants.PURCHASE_ORDER_SUMMARY_TOOLS
                          | translate: { value: modelsSummaryLength }
                      }}
                    </div>

                    <div class="services-summary">
                      <div
                        *ngFor="let modelProp of modelsSummary | keyvalue"
                        class="services-summary-service">
                        <ul>
                          <li
                            *ngFor="let serialNumber of modelProp.value"
                            class="services-summary-serial">
                            <span>{{ serialNumber }}</span>
                          </li>
                        </ul>
                        <div class="flex end services-summary-service-name">
                          {{ modelProp.key }}
                        </div>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-step>
        </mat-stepper>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
